import http from '../../services/http-common';

class FullYarnCountInfoService {
    
    getFullYarnCountInfoForList() {
    return http.get(`/FullYarnCountInfo/sp/list`);
    }
    insert(data) {
        return http.post(`/FullYarnCountInfo/db/add`,data);
    }
    update(data) {
        return http.put(`/FullYarnCountInfo/db/update`,data);
    }
}

export default new FullYarnCountInfoService();